export function stringArraysMatchAsMultisets(
  a: string[],
  b: string[],
): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const sa = [...a].sort((x, y) => x.localeCompare(y));
  const sb = [...b].sort((x, y) => x.localeCompare(y));
  return sa.every((v, i) => v === sb[i]);
}

export function labelsForFullBoxSelect(
  options: { label: string; disabled?: boolean }[],
  limit?: number,
): string[] {
  const labels = options.reduce(
    (acc, option) => (option.disabled ? acc : acc.add(option.label)),
    new Set<string>(),
  );

  const arrayOfLabels = Array.from(labels);

  return limit
    ? arrayOfLabels.slice(0, Math.min(limit, arrayOfLabels.length))
    : arrayOfLabels;
}
